import { searchCities } from 'shared';

import { pfm as api } from './client';
import { sentryModel } from '../model';

export function fetchCities(query: string, onlyKZCities?: boolean) {
  return api.dict
    .citiesSearch({ query, page_size: 10 })
    .then(({ data }) => {
      const mappedCities = searchCities.lib.getMappedCities(data.results);
      if (onlyKZCities) {
        return mappedCities.filter(city => city.country.code === 'KZ');
      }
      return mappedCities;
    })
    .catch(err => {
      sentryModel.captureException(
        sentryModel.getReadableError('ERR_FAILED_TO_FETCH_CITIES', err),
      );
      throw err;
    });
}
